import { createContext, useContext } from 'react';

/**
 * Bridges the home Workspace pane and the inline chat so a people result that
 * is mirrored in the pane isn't ALSO rendered full-size inline (the duplicate
 * the audit flagged). CopilotSplit provides the id of the result currently in
 * the pane; ToolResultSurface reads it and collapses that one inline render to
 * a compact "shown in the Workspace" reference. Defaults to null everywhere
 * else (docked sidebar, /clu) so those keep rendering results inline.
 */
export const CopilotPaneContext = createContext<{
  mirroredResultId: string | null;
}>({ mirroredResultId: null });

export const useCopilotPane = () => useContext(CopilotPaneContext);
